import { render, staticRenderFns } from "./YzDialogFullscreenHeader.vue?vue&type=template&id=426faea5&scoped=true&lang=pug&"
import script from "./YzDialogFullscreenHeader.vue?vue&type=script&lang=js&"
export * from "./YzDialogFullscreenHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426faea5",
  null
  
)

export default component.exports